export default __webpack_public_path__ + "static/media/on-demand.113160b0.svg";